<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const schema = defineSchema({
	title: $.text('Title', { default: 'All Topics' }),
	subtitle: $.text('Subtitle', { default: 'Browse all topics covered on TheTorah.com' }),
	searchPlaceholder: $.text('Search Placeholder', { default: 'Search topics...' }),
})
export const BlockAllTopics = defineBlock({ thumbnail: '/block-thumbs/BlockAllTopics.svg', category: 'Listings', order: 90,
	name: 'BlockAllTopics',
	label: 'All Topics',
	icon: 'topic',
	schema,
	dataSource: { collection: 'topics', store: 'the_torah', label: 'Topics' },
})
</script>
<script setup lang="ts">
import { useBloxRuntime } from '@bagelink/blox'
import { TextInput } from '@bagelink/vue'
import { computed, ref } from 'vue'
import { useCollection } from '@/composables/useDatastore'



interface Topic {
	name: string
	link: string
}

defineProps<{
	title?: string
	subtitle?: string
	searchPlaceholder?: string
}>()

const PREVIEW_TOPICS: Topic[] = [
	{ name: 'The Composition of the Torah', link: '/' },
	{ name: 'Archaeology and the Bible', link: '/' },
	{ name: 'Modern Faith', link: '/' },
	{ name: 'Ancient Near Eastern Context', link: '/' },
]

const searchTerm = ref('')
const { isPreview } = useBloxRuntime()
const { items: datastoreTopics, loading } = useCollection('topics', {
	limit: 2000,
	pick: ['id', '_id', 'name', 'slug'],
})
const topics = computed<Topic[]>(() => {
	const mapped = datastoreTopics.value.map((topic: any) => ({
		name: topic.name || '',
		link: `/topic/${topic.slug}`,
	}))
	if (mapped.length || loading.value || !isPreview.value) return mapped
	return PREVIEW_TOPICS
})

const filteredTopics = computed(() => {
	const allTopics = topics.value
	if (!searchTerm.value) {
		return allTopics
	}
	return allTopics.filter(topic => topic.name.toLowerCase().includes(searchTerm.value.toLowerCase()))
})
</script>

<template>
	<div class="w800px my-3">
		<div class="txt-center">
			<h1 class="m-0 txt40 regular line-height-14 m_txt32 balance pb-1 m_pb-075">
				{{ title }}
			</h1>
			<p class="m-0 pretty">
				{{ subtitle }}
			</p>

			<TextInput
				v-model="searchTerm"
				class="w400px py-2 m_w300px"
				:placeholder="searchPlaceholder"
			/>
		</div>

		<div class="grid grid-wrap-2">
			<router-link
				v-for="topic in filteredTopics"
				:key="topic.name"
				:to="topic.link"
				class="txt21 bold py-1 px-2 decoration-none hover-bg-gray-100 block"
			>
				{{ topic.name }}
			</router-link>
		</div>
	</div>
</template>
